document.addEventListener('click', (event) => {
    // クリックされた要素が .js-toggle-sp-menu またはその子要素かを確認
    const menuToggle = event.target.closest('.js-toggle-sp-menu');

    if (menuToggle) {
        const modal = document.querySelector('.l-header__nav--sp__modal');
        const body = document.querySelector('body');

        if (modal && body) {
            menuToggle.classList.toggle('is-open');
            modal.classList.toggle('is-open');
            body.classList.toggle('is-fixed'); // 背景固定用クラス
        }
    }
});
